export default __webpack_public_path__ + "static/media/Pre-trained.59a37789.svg";